const firstNameLength = 50;
const lastNameLength = 50;
const phoneNumberLength = 20;
const mailLength = 50;
const paycardNumberLength = 9;
const companyNameLength = 50;
const maximumImageHeight = 1280;
const maximumImageWidth = 1920;
const maximumDpi = 300;
const maximumUriLength = 255;

const minumumVoucherAmount = 1;
const maximumVoucherAmount = 9999;
const maximumMoneyDecimalCount = 2;

const maximumPercentageDecimalCount = 2;
const minPercentage = 0;

const maxPercentage = 100;

export {
    firstNameLength,
    lastNameLength,
    phoneNumberLength,
    mailLength,
    paycardNumberLength,
    companyNameLength,
    maximumImageHeight,
    maximumImageWidth,
    maximumDpi,
    maximumUriLength,
    minumumVoucherAmount,
    maximumVoucherAmount,
    maximumMoneyDecimalCount,
    maximumPercentageDecimalCount,
    minPercentage,
    maxPercentage
}
